<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">Hi~ <a class="font3">{{ ReportData.stuname }}</a>，我们又见面啦</p>
        <p  class="font1">每一分耕耘，皆为收获</p>
        <p  class="font1">让我们以此为起点</p>
        <p  class="font1">迈向下一个学习高峰！</p>


        <p  class="font1"><a class="font3">2025</a>年<a class="font3">五月</a></p>
        <p class="font1" v-if="ReportData.studate !==null" >你已经学习了<a class="font3">{{ ReportData.studate }}</a>天</p>
        <p class="font1" v-if="ReportData.playtime !==null">累计学习了<a class="font3">{{ ReportData.playtime }}</a>小时</p>

        <p class="font1" v-if="ReportData.coursenumMon !==null" style="padding-top: 1.5vh;">学习了<a class="font3">{{ ReportData.coursenumMon }}</a>门课程</p>
        <p class="font1" v-if="ReportData.coursenum !==null && ReportData.coursenum !==0" >完成了<a class="font3">{{ ReportData.coursenum }}</a>门课程</p>

        <p class="font1" v-if="ReportData.examTimes !==null" style="padding-top: 1.5vh;">累计考试<a class="font3">{{ ReportData.examTimes}}</a>次</p>
        <p class="font1" v-if="ReportData.creditvalue !==null">获得学分<a class="font3">{{ ReportData.creditvalue }}</a>分</p>
        
        <p class="font1" style="margin: 0 auto;padding-top: 1.5vh;" v-if="ReportData.studate ===null">你还没有在富学宝典上学习，<br>请继续加油！</p>
        <!-- <p style="font-size: 15px;text-align: center;margin-top: 7vh;margin-bottom: 0;">第一季度的学习报告已为你生成</p> -->
        <p style="font-size: 15px;text-align: center;margin: 0;;margin-top: 5vh;">赶快来开启专属于你的学习报告吧～</p>
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
}
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/25March/logo.png") right  top  no-repeat,
                url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/25May/bg.jpg")  no-repeat;
    background-size:100% 100%, 55%,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 92%;
    margin: 0;
    text-align: right;
    font-size: 20px;
    color: #000;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #26a5e1;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>